import React from 'react';
import {
  Element,
  FontType,
  Typography,
  Icon
} from '@americanexpress/aqx-components';
import styles from './__styles__/platFront.scss?modules';

const PlatFront = ({
  header,
  disclaimerMobile,
  disclaimerMobile2,
  logoMobile,
  logoAlt,
  iconMobile,
  mobileLogoWidth
}) => (
  <Element className={styles.contentContainer}>
    <Typography
      $family={FontType.HelveticaBold}
      $size={13}
      $lineHeight={18}
      className={styles.header}
    >
      {header}
    </Typography>
    {logoMobile && (
      <Element className={styles.logoContainer}>
        <Element
          style={{ width: mobileLogoWidth }}
          Component="img"
          src={logoMobile}
          alt={logoAlt}
        />
      </Element>
    )}
    {iconMobile && (
      <Icon className={styles.logo} directory="dls" imageName={iconMobile} />
    )}
    <Typography
      $family={FontType.HelveticaRegular}
      $size={13}
      $lineHeight={20}
      className={styles.disclaimerMobile}
    >
      {disclaimerMobile}
    </Typography>
    {disclaimerMobile2 && (
      <Typography
        $family={FontType.HelveticaRegular}
        $size={13}
        $lineHeight={20}
        className={styles.disclaimerMobile2}
      >
        {disclaimerMobile2}
      </Typography>
    )}
  </Element>
);

export default PlatFront;
